<template>
	<div class="page">
		<div class="screenLine">
			<el-input v-model="search.keyword" @keyup.enter.native="changeSearch" placeholder="输入关键字" style="width:240px;margin-right: 16px;"></el-input>
			<el-select v-model="search.sex" @change="changeSearch" placeholder="选择性别" style="width:130px;margin-right: 16px;">
				<el-option v-for="item in [{label:'全部',value:-1},{label:'男',value:1},{label:'女',value:0}]" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<!-- <el-select v-model="search.state" placeholder="选择宠物类别" style="width:130px;margin-right: 16px;">
				<el-option v-for="item in [{label:'全部',value:-1},{label:'男',value:1},{label:'女',value:0}]" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select> -->
			<el-button type="warning" @click="reset">重置</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" height="100%">
				<el-table-column prop="no" label="序号" width="50">
					<template slot-scope="scope">
						{{scope.$index+1}}
					</template>
				</el-table-column>
				<el-table-column label="用户" width="120">
					<template slot-scope="scope" v-if="scope.row.vip_grades">
						<span >
							<img v-if="scope.row.vip_grades.grades==1" style="width:45px;padding-right: 6px;vertical-align: bottom;" src="../../../assets/img/member/vip1.png"/>
							<img v-if="scope.row.vip_grades.grades==2" style="width:45px;padding-right: 6px;vertical-align: bottom;" src="../../../assets/img/member/vip2.png"/>
							<img v-if="scope.row.vip_grades.grades==3" style="width:45px;padding-right: 6px;vertical-align: bottom;" src="../../../assets/img/member/vip3.png"/>
							<img v-if="scope.row.vip_grades.grades==4" style="width:45px;padding-right: 6px;vertical-align: bottom;" src="../../../assets/img/member/vip4.png"/>
							<img v-if="scope.row.vip_grades.grades==5" style="width:45px;padding-right: 6px;vertical-align: bottom;" src="../../../assets/img/member/vip5.png"/>
							{{scope.row.basic_info.nick_name}}
							<span v-if="scope.row.lifeLong&&scope.row.lifeLong.status===1">
								<el-tooltip effect="dark" :content="scope.row.lifeLong.remark" placement="top-start">
									<img style="height: 16px;cursor: pointer;" src="../../../assets/img/member/zhong.png"/>
								</el-tooltip>
							</span>
							<span v-if="scope.row.vip_grades.grades===3&&scope.row.vip_grades.old_interest===true" style="color:#E6A23C">(老)</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column label="电话">
					<template slot-scope="scope">
						{{scope.row.basic_info.user_mobile}}
					</template>
				</el-table-column>
				<el-table-column label="性别" >
					<template slot-scope="scope">
						{{scope.row.basic_info.sex}}
					</template>
				</el-table-column>
				<el-table-column label="宠物" >
					<template slot-scope="scope">
						<div
						v-for="(item,index) in scope.row.pets_info"
						:key="index"
						@click="seePet(scope.row,item)">
							<img v-if="item.hs_pet" style="width:30px;padding-right: 6px;vertical-align: text-bottom;" src="../../../assets/img/member/vip_pet.png"/>
							<span >{{item.nick_name}}</span> ({{item.category_info.name}})
						</div>
					</template>
				</el-table-column>
				<el-table-column label="余额" >
					<template slot-scope="scope">
						{{scope.row.card_info.user_yue>0?(scope.row.card_info.user_yue).toFixed(2):0}}
					</template>
				</el-table-column>
				<el-table-column label="注册时间" width="180">
					<template slot-scope="scope">
						{{scope.row.operation_info&&$public.FTime(scope.row.operation_info.create.create_time)}}
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="80">
					<template slot-scope="scope">
						<el-button type="text" @click="see(scope.row)">查看</el-button>
						<el-button type="text" @click="curRow=scope.row;drawerMemberEdit_state=true">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagePosi">
			<page style="padding:10px 0;" :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
		<div v-if="drawerMemberEdit_state">
			<drawerMemberEdit :id="curRow._id" @submit="submit_drawerMemberEdit"></drawerMemberEdit>
		</div>
	</div>
</template>

<script>
	import page from "@/components/page.vue"
	import drawerMemberEdit from "./drawer_memberEdit.vue"
	export default {
		components:{page,drawerMemberEdit},
		data() {
			return {
				search: {
					sex:-1,
					keyword:'',
				},
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData:[],
				
				// 编辑
				drawerMemberEdit_state:false,
				curRow:{},
				
			}
		},
		computed:{
			
		},
		created(){
			
		},
		mounted(){
			this.getTableData()
		},
		methods:{
			// 查看
			see(row){
				this.$router.push({path:"/member/memberSee?id="+row._id})
			},
			seePet(row,petItem){
				console.log(row,petItem)
				// this.$router.push({path:"/member/memberSee",query:{uid:row._id,pId:petItem._id}})
			},
			// 编辑
			submit_drawerMemberEdit(){
				this.drawerMemberEdit_state = false;
			},
			
			// 列表
			reset(){
				this.search.keyword=''
				this.search.sex=-1
				this.page.page = 1;
				this.getTableData()
			},
			changeSearch(){
				this.page.page = 1;
				this.getTableData()
			},
			changePage(num){
				this.page.page = num;
				this.getTableData()
			},
			getTableData(){
				let params = {
					"shop_id": "",
					"hs_vip": -1,
					"hs_pet": -1,
					"class_name": "",
					"startTime": "",
					"endTime": "",
					"field": "",
					"keyword": this.search.keyword,
					"source": "",
					"staff_type": "",
					"grades": -1,
					"sex": this.search.sex, // -1全部 0女 1男
					"buyBackStatus": -1,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_member+'/api/middleware/member/list', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.tableData = res.data.data||[];
						this.page.total = res.data.count;
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.page{
		padding:16px 16px 65px 16px;height: 100%;box-sizing: border-box;position: relative;
		.screenLine{
			
		}
		.tableBox{
			padding:16px;border-radius: 8px;background-color: #fff;box-sizing: border-box;margin-top:16px;height: calc(100% - 56px);
		}
		
		.pagePosi{
			position: absolute;bottom:0;left:16px;right:16px;text-align:right;background-color: #fff;padding:0 10px;border-radius: 8px 8px 0 0;
		}
	}
</style>
